import { AdminIcon as NewAdminIcon, AdminLogoCS as NewAdminLogo } from '@atlaskit/temp-nav-app-icons/admin';
import { AlignIcon as NewAlignIcon, AlignLogoCS as NewAlignLogo } from '@atlaskit/temp-nav-app-icons/align';
import { AnalyticsIcon as NewAnalyticsIcon, AnalyticsLogoCS as NewAnalyticsLogo } from '@atlaskit/temp-nav-app-icons/analytics';
import { AssetsIcon as NewAssetsIcon, AssetsLogoCS as NewAssetsLogo } from '@atlaskit/temp-nav-app-icons/assets';
import { BambooIcon as NewBambooIcon, BambooLogoCS as NewBambooLogo } from '@atlaskit/temp-nav-app-icons/bamboo';
import { BitbucketIcon as NewBitbucketIcon, BitbucketLogoCS as NewBitbucketLogo } from '@atlaskit/temp-nav-app-icons/bitbucket';
import { BitbucketDataCenterIcon as NewBitbucketDataCenterIcon, BitbucketDataCenterLogoCS as NewBitbucketDataCenterLogo } from '@atlaskit/temp-nav-app-icons/bitbucket-data-center';
import { ChatIcon as NewChatIcon, ChatLogoCS as NewChatLogo } from '@atlaskit/temp-nav-app-icons/chat';
import { CompassIcon as NewCompassIcon, CompassLogoCS as NewCompassLogo } from '@atlaskit/temp-nav-app-icons/compass';
import { ConfluenceIcon as NewConfluenceIcon, ConfluenceLogoCS as NewConfluenceLogo } from '@atlaskit/temp-nav-app-icons/confluence';
import { ConfluenceDataCenterIcon as NewConfluenceDataCenterIcon, ConfluenceDataCenterLogoCS as NewConfluenceDataCenterLogo } from '@atlaskit/temp-nav-app-icons/confluence-data-center';
import { CrowdIcon as NewCrowdIcon, CrowdLogoCS as NewCrowdLogo } from '@atlaskit/temp-nav-app-icons/crowd';
import { CustomerServiceManagementIcon as NewCustomerServiceManagementIcon, CustomerServiceManagementLogoCS as NewCustomerServiceManagementLogo } from '@atlaskit/temp-nav-app-icons/customer-service-management';
import { FocusIcon as NewFocusIcon, FocusLogoCS as NewFocusLogo } from '@atlaskit/temp-nav-app-icons/focus';
import { GoalsIcon as NewGoalsIcon, GoalsLogoCS as NewGoalsLogo } from '@atlaskit/temp-nav-app-icons/goals';
import { GuardIcon as NewGuardIcon, GuardLogoCS as NewGuardLogo } from '@atlaskit/temp-nav-app-icons/guard';
import { HomeIcon as NewHomeIcon, HomeLogoCS as NewHomeLogo } from '@atlaskit/temp-nav-app-icons/home';
import { HubIcon as NewHubIcon, HubLogoCS as NewHubLogo } from '@atlaskit/temp-nav-app-icons/hub';
import { JiraIcon as NewJiraIcon, JiraLogoCS as NewJiraLogo } from '@atlaskit/temp-nav-app-icons/jira';
import { JiraDataCenterIcon as NewJiraDataCenterIcon, JiraDataCenterLogoCS as NewJiraDataCenterLogo } from '@atlaskit/temp-nav-app-icons/jira-data-center';
import { JiraProductDiscoveryIcon as NewJPDIcon, JiraProductDiscoveryLogoCS as NewJPDLogo } from '@atlaskit/temp-nav-app-icons/jira-product-discovery';
import { JiraServiceManagementIcon as NewJSMIcon, JiraServiceManagementLogoCS as NewJSMLogo } from '@atlaskit/temp-nav-app-icons/jira-service-management';
import { JiraServiceManagementDataCenterIcon as NewJiraServiceManagementDataCenterIcon, JiraServiceManagementDataCenterLogoCS as NewJiraServiceManagementDataCenterLogo } from '@atlaskit/temp-nav-app-icons/jira-service-management-data-center';
import { LoomIcon as NewLoomIcon, LoomLogoCS as NewLoomLogo } from '@atlaskit/temp-nav-app-icons/loom';
import { LoomAttributionLogoCS as NewLoomAttributionLogo } from '@atlaskit/temp-nav-app-icons/loom-attribution';
import { LoomInternalIcon as NewLoomInternalIcon, LoomInternalLogoCS as NewLoomInternalLogo } from '@atlaskit/temp-nav-app-icons/loom-internal';
import { OpsgenieIcon as NewOpsgenieIcon, OpsgenieLogoCS as NewOpsgenieLogo } from '@atlaskit/temp-nav-app-icons/opsgenie';
import { ProjectsIcon as NewProjectsIcon, ProjectsLogoCS as NewProjectsLogo } from '@atlaskit/temp-nav-app-icons/projects';
import { RovoIcon as NewRovoIcon, RovoLogoCS as NewRovoLogo } from '@atlaskit/temp-nav-app-icons/rovo';
import { SearchIcon as NewSearchIcon, SearchLogoCS as NewSearchLogo } from '@atlaskit/temp-nav-app-icons/search';
import { StatuspageIcon as NewStatuspageIcon, StatuspageLogoCS as NewStatuspageLogo } from '@atlaskit/temp-nav-app-icons/statuspage';
import { StudioIcon as NewStudioIcon, StudioLogoCS as NewStudioLogo } from '@atlaskit/temp-nav-app-icons/studio';
import { TalentIcon as NewTalentIcon, TalentLogoCS as NewTalentLogo } from '@atlaskit/temp-nav-app-icons/talent';
import { TeamsIcon as NewTeamsIcon, TeamsLogoCS as NewTeamsLogo } from '@atlaskit/temp-nav-app-icons/teams';
import { TrelloIcon as NewTrelloIcon, TrelloLogoCS as NewTrelloLogo } from '@atlaskit/temp-nav-app-icons/trello';
import { AtlassianAdminIcon as LegacyAtlassianAdminIcon, AtlassianAdminLogo as LegacyAtlassianAdminLogo } from './legacy-logos/atlassian-admin';
import { AtlassianAdministrationIcon as LegacyAtlassianAdministrationIcon, AtlassianAdministrationLogo as LegacyAtlassianAdministrationLogo } from './legacy-logos/atlassian-administration';
import { AtlassianAnalyticsIcon as LegacyAtlassianAnalyticsIcon, AtlassianAnalyticsLogo as LegacyAtlassianAnalyticsLogo } from './legacy-logos/atlassian-analytics';
import { BitbucketIcon as LegacyBitbucketIcon, BitbucketLogo as LegacyBitbucketLogo } from './legacy-logos/bitbucket';
import { CompassIcon as LegacyCompassIcon, CompassLogo as LegacyCompassLogo } from './legacy-logos/compass';
import { ConfluenceIcon as LegacyConfluenceIcon, ConfluenceLogo as LegacyConfluenceLogo } from './legacy-logos/confluence';
import { FocusIcon as LegacyFocusIcon, FocusLogo as LegacyFocusLogo } from './legacy-logos/focus';
import { GuardIcon as LegacyGuardIcon, GuardLogo as LegacyGuardLogo } from './legacy-logos/guard';
import { JiraIcon as LegacyJiraIcon, JiraLogo as LegacyJiraLogo } from './legacy-logos/jira';
import { JiraAlignIcon as LegacyJiraAlignIcon, JiraAlignLogo as LegacyJiraAlignLogo } from './legacy-logos/jira-align';
import { JiraProductDiscoveryIcon as LegacyJPDIcon, JiraProductDiscoveryLogo as LegacyJPDLogo } from './legacy-logos/jira-product-discovery';
import { JiraServiceManagementIcon as LegacyJSMIcon, JiraServiceManagementLogo as LegacyJSMLogo } from './legacy-logos/jira-service-management';
import { LoomIcon as LegacyLoomIcon, LoomLogo as LegacyLoomLogo } from './legacy-logos/loom';
import { LoomAttributionIcon as LegacyLoomAttributionIcon, LoomAttributionLogo as LegacyLoomAttributionLogo } from './legacy-logos/loom-attribution';
import { OpsgenieIcon as LegacyOpsgenieIcon, OpsgenieLogo as LegacyOpsgenieLogo } from './legacy-logos/opsgenie';
import { RovoIcon as LegacyRovoIcon, RovoLogo as LegacyRovoLogo } from './legacy-logos/rovo';
import { StatuspageIcon as LegacyStatuspageIcon, StatuspageLogo as LegacyStatuspageLogo } from './legacy-logos/statuspage';
import { TrelloIcon as LegacyTrelloIcon, TrelloLogo as LegacyTrelloLogo } from './legacy-logos/trello';
export { AtlasIcon, AtlasLogo } from './legacy-logos/atlas';
export { AtlassianMarketplaceIcon, AtlassianMarketplaceLogo } from './legacy-logos/atlassian-marketplace';
export { AtlassianAccessIcon, AtlassianAccessLogo } from './legacy-logos/atlassian-access';
export { JiraWorkManagementLogo, JiraWorkManagementIcon } from './legacy-logos/jira-work-management';
export { AtlassianIcon, AtlassianLogo } from './legacy-logos/atlassian';
export { JiraSoftwareIcon, JiraSoftwareLogo } from './legacy-logos/jira-software';
import { createFeatureFlaggedComponent, createFeatureFlaggedServiceCollectionComponent, tempSizeWrapper } from './logo-config';

/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AdminIcon = tempSizeWrapper(NewAdminIcon);
/**
 * __Admin logo__
 *
 * The Admin logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AdminLogo = tempSizeWrapper(NewAdminLogo);

/**
 * __Analytics icon__
 *
 * The Analytics icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AnalyticsIcon = tempSizeWrapper(NewAnalyticsIcon);
/**
 * __Analytics logo__
 *
 * The Analytics logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AnalyticsLogo = tempSizeWrapper(NewAnalyticsLogo);

/**
 * __Assets icon__
 *
 * The Assets icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AssetsIcon = tempSizeWrapper(NewAssetsIcon);
/**
 * __Assets logo__
 *
 * The Assets logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AssetsLogo = tempSizeWrapper(NewAssetsLogo);
/**
 * __Chat icon__
 *
 * The Chat icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var ChatIcon = tempSizeWrapper(NewChatIcon);
/**
 * __Chat logo__
 *
 * The Chat logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var ChatLogo = tempSizeWrapper(NewChatLogo);
/**
 * __Customer Service Management icon__
 *
 * The Customer service management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var CustomerServiceManagementIcon = tempSizeWrapper(NewCustomerServiceManagementIcon);
/**
 * __Customer Service Management logo__
 *
 * The Customer service management logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var CustomerServiceManagementLogo = tempSizeWrapper(NewCustomerServiceManagementLogo);
/**
 * __Goals icon__
 *
 * The Goals icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var GoalsIcon = tempSizeWrapper(NewGoalsIcon);
/**
 * __Goals logo__
 *
 * The Goals logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var GoalsLogo = tempSizeWrapper(NewGoalsLogo);
/**
 * __Home icon__
 *
 * The Home icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var HomeIcon = tempSizeWrapper(NewHomeIcon);
/**
 * __Home logo__
 *
 * The Home logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var HomeLogo = tempSizeWrapper(NewHomeLogo);
/**
 * __Hub icon
 *
 * The Hub icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var HubIcon = tempSizeWrapper(NewHubIcon);
/**
 * Hub logo__
 *
 * The Hub logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var HubLogo = tempSizeWrapper(NewHubLogo);
/**
 * __Projects icon__
 *
 * The Projects icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var ProjectsIcon = tempSizeWrapper(NewProjectsIcon);
/**
 * __Projects logo__
 *
 * The Projects logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var ProjectsLogo = tempSizeWrapper(NewProjectsLogo);
/**
 * __Search icon__
 *
 * The Search icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var SearchIcon = tempSizeWrapper(NewSearchIcon);
/**
 * __Search logo__
 *
 * The Search logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var SearchLogo = tempSizeWrapper(NewSearchLogo);
/**
 * __Studio icon__
 *
 * The Studio icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var StudioIcon = tempSizeWrapper(NewStudioIcon);
/**
 * __Studio logo__
 *
 * The Studio logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var StudioLogo = tempSizeWrapper(NewStudioLogo);
/**
 * __Talent icon__
 *
 * The Talent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var TalentIcon = tempSizeWrapper(NewTalentIcon);
/**
 * __Talent logo__
 *
 * The Talent logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var TalentLogo = tempSizeWrapper(NewTalentLogo);
/**
 * __Teams icon__
 *
 * The Teams icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var TeamsIcon = tempSizeWrapper(NewTeamsIcon);
/**
 * __Teams logo__
 *
 * The Teams logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var TeamsLogo = tempSizeWrapper(NewTeamsLogo);
/**
 * __Bamboo icon__
 *
 * The Bamboo icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var BambooIcon = tempSizeWrapper(NewBambooIcon);
/**
 * __Bamboo logo__
 *
 * The Bamboo logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var BambooLogo = tempSizeWrapper(NewBambooLogo);
/**
 * __Bitbucket Data Center icon__
 *
 * The Bitbucket Data Center icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var BitbucketDataCenterIcon = tempSizeWrapper(NewBitbucketDataCenterIcon);
/**
 * __Bitbucket Data Center logo__
 *
 * The Bitbucket Data Center logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var BitbucketDataCenterLogo = tempSizeWrapper(NewBitbucketDataCenterLogo);
/**
 * __Confluence Data Center icon__
 *
 * The Confluence Data Center icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var ConfluenceDataCenterIcon = tempSizeWrapper(NewConfluenceDataCenterIcon);
/**
 * __Confluence Data Center logo__
 *
 * The Confluence Data Center logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var ConfluenceDataCenterLogo = tempSizeWrapper(NewConfluenceDataCenterLogo);
/**
 * __Crowd icon__
 *
 * The Crowd icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var CrowdIcon = tempSizeWrapper(NewCrowdIcon);
/**
 * __Crowd logo__
 *
 * The Crowd logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var CrowdLogo = tempSizeWrapper(NewCrowdLogo);

/**
 * __Jira Data Center icon__
 *
 * The Jira Data Center icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var JiraDataCenterIcon = tempSizeWrapper(NewJiraDataCenterIcon);
/**
 * __Jira Data Center logo__
 *
 * The Jira Data Center logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var JiraDataCenterLogo = tempSizeWrapper(NewJiraDataCenterLogo);

/**
 * __Jira Service Management Data Center icon__
 *
 * The Jira Service Management Data Center icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var JiraServiceManagementDataCenterIcon = tempSizeWrapper(NewJiraServiceManagementDataCenterIcon);
/**
 * __Jira Service Management Data Center logo__
 *
 * The Jira Service Management Data Center logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var JiraServiceManagementDataCenterLogo = tempSizeWrapper(NewJiraServiceManagementDataCenterLogo);

/**
 * __Atlassian Administration icon__
 *
 * The Atlassian Administration icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AtlassianAdministrationIcon = createFeatureFlaggedComponent(LegacyAtlassianAdministrationIcon, NewAdminIcon);

/**
 * __Atlassian Administration logo__
 *
 * The Atlassian Administration logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AtlassianAdministrationLogo = createFeatureFlaggedComponent(LegacyAtlassianAdministrationLogo, NewAdminLogo);

/**
 * __Atlassian Admin icon__
 *
 * The Atlassian Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AtlassianAdminIcon = createFeatureFlaggedComponent(LegacyAtlassianAdminIcon, NewAdminIcon);

/**
 * __Atlassian Admin logo__
 *
 * The Atlassian Admin logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AtlassianAdminLogo = createFeatureFlaggedComponent(LegacyAtlassianAdminLogo, NewAdminLogo);

/**
 * __Atlassian Analytics icon__
 *
 * The Atlassian Analytics icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AtlassianAnalyticsIcon = createFeatureFlaggedComponent(LegacyAtlassianAnalyticsIcon, NewAnalyticsIcon);
/**
 * __Atlassian Analytics logo__
 *
 * The Atlassian Analytics logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AtlassianAnalyticsLogo = createFeatureFlaggedComponent(LegacyAtlassianAnalyticsLogo, NewAnalyticsLogo);

/**
 * __Bitbucket icon__
 *
 * The Bitbucket icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var BitbucketIcon = createFeatureFlaggedComponent(LegacyBitbucketIcon, NewBitbucketIcon);
/**
 * __Bitbucket logo__
 *
 * The Bitbucket logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var BitbucketLogo = createFeatureFlaggedComponent(LegacyBitbucketLogo, NewBitbucketLogo);
/**
 * __Compass icon__
 *
 * The Compass icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var CompassIcon = createFeatureFlaggedComponent(LegacyCompassIcon, NewCompassIcon);
/**
 * __Compass logo__
 *
 * The Compass logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var CompassLogo = createFeatureFlaggedComponent(LegacyCompassLogo, NewCompassLogo);

/**
 * __Confluence icon__
 *
 * The Confluence icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var ConfluenceIcon = createFeatureFlaggedComponent(LegacyConfluenceIcon, NewConfluenceIcon);
/**
 * __Confluence logo__
 *
 * The Confluence logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var ConfluenceLogo = createFeatureFlaggedComponent(LegacyConfluenceLogo, NewConfluenceLogo);

/**
 * __Align icon__
 *
 * The Align icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AlignIcon = tempSizeWrapper(NewAlignIcon);
/**
 * __Align logo__
 *
 * The Align logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var AlignLogo = tempSizeWrapper(NewAlignLogo);

/**
 * __Jira Align icon__
 *
 * The Jira Align icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var JiraAlignIcon = createFeatureFlaggedComponent(LegacyJiraAlignIcon, NewAlignIcon);
/**
 * __Jira Align logo__
 *
 * The Jira Align logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var JiraAlignLogo = createFeatureFlaggedComponent(LegacyJiraAlignLogo, NewAlignLogo);

/**
 * __Jira icon__
 *
 * The Jira icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var JiraIcon = createFeatureFlaggedComponent(LegacyJiraIcon, NewJiraIcon);
/**
 * __Jira logo__
 *
 * The Jira logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var JiraLogo = createFeatureFlaggedComponent(LegacyJiraLogo, NewJiraLogo);
/**
 * __Jira product discovery icon__
 *
 * The Jira Product Discovery icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var JiraProductDiscoveryIcon = createFeatureFlaggedComponent(LegacyJPDIcon, NewJPDIcon);

/**
 * __Jira product discovery logo__
 *
 * The Jira Product Discovery logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var JiraProductDiscoveryLogo = createFeatureFlaggedComponent(LegacyJPDLogo, NewJPDLogo);

/**
 * __Jira service management icon__
 *
 * The Jira Service Management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var JiraServiceManagementIcon = createFeatureFlaggedServiceCollectionComponent(LegacyJSMIcon, NewJSMIcon);

/**
 * __Jira service management logo__
 *
 * The Jira Service Management logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var JiraServiceManagementLogo = createFeatureFlaggedServiceCollectionComponent(LegacyJSMLogo, NewJSMLogo);

/**
 * __Loom icon__
 *
 * The Loom icon, in Teamwork Blue, without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var LoomIcon = createFeatureFlaggedComponent(LegacyLoomIcon, NewLoomIcon);
/**
 * __Loom logo__
 *
 * The Loom logo, in Teamwork Blue, with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var LoomLogo = createFeatureFlaggedComponent(LegacyLoomLogo, NewLoomLogo);
/**
 * __Loom Attribution icon__
 *
 * The Loom Attribution icon, in Teamwork Blue, without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var LoomAttributionIcon = createFeatureFlaggedComponent(LegacyLoomAttributionIcon, NewLoomIcon);
/**
 * __Loom Attribution logo__
 *
 * The Loom Attribution logo, in Teamwork Blue, with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var LoomAttributionLogo = createFeatureFlaggedComponent(LegacyLoomAttributionLogo, NewLoomAttributionLogo);
/**
 * __Loom (Blurple) logo__
 *
 * The Loom logo, in the Loom Blurple color, with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var LoomBlurpleLogo = tempSizeWrapper(NewLoomInternalLogo);
/**
 * __Loom (Blurple) icon__
 *
 * The Loom icon, in the Loom Blurple color, without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var LoomBlurpleIcon = tempSizeWrapper(NewLoomInternalIcon);
/**
 * __Opsgenie icon__
 *
 * The Opsgenie icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var OpsgenieIcon = createFeatureFlaggedServiceCollectionComponent(LegacyOpsgenieIcon, NewOpsgenieIcon);
/**
 * __Opsgenie logo__
 *
 * The Opsgenie logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var OpsgenieLogo = createFeatureFlaggedServiceCollectionComponent(LegacyOpsgenieLogo, NewOpsgenieLogo);

/**
 * __Statuspage icon__
 *
 * The Statuspage icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var StatuspageIcon = createFeatureFlaggedServiceCollectionComponent(LegacyStatuspageIcon, NewStatuspageIcon);
/**
 * __Statuspage logo__
 *
 * The Statuspage logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var StatuspageLogo = createFeatureFlaggedServiceCollectionComponent(LegacyStatuspageLogo, NewStatuspageLogo);
/**
 * __Trello icon__
 *
 * The Trello icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var TrelloIcon = createFeatureFlaggedComponent(LegacyTrelloIcon, NewTrelloIcon);
/**
 * __Trello logo__
 *
 * The Trello logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var TrelloLogo = createFeatureFlaggedComponent(LegacyTrelloLogo, NewTrelloLogo);
/**
 * __Rovo icon__
 *
 * The Rovo icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var RovoIcon = createFeatureFlaggedServiceCollectionComponent(LegacyRovoIcon, NewRovoIcon);
/**
 * __Rovo logo__
 *
 * The Rovo logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var RovoLogo = createFeatureFlaggedServiceCollectionComponent(LegacyRovoLogo, NewRovoLogo);

/**
 * __Guard icon__
 *
 * The Guard icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var GuardIcon = createFeatureFlaggedComponent(LegacyGuardIcon, NewGuardIcon);
/**
 * __Guard logo__
 *
 * The Guard logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var GuardLogo = createFeatureFlaggedComponent(LegacyGuardLogo, NewGuardLogo);

/**
 * __Focus icon__
 *
 * The Focus icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var FocusIcon = createFeatureFlaggedComponent(LegacyFocusIcon, NewFocusIcon);
/**
 * __Focus logo__
 *
 * The Focus logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var FocusLogo = createFeatureFlaggedComponent(LegacyFocusLogo, NewFocusLogo);